import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {CreateDialogComponent} from '../create-dialog/create-dialog.component';
import {MAT_DIALOG_DATA, MatDialog, MatTableDataSource} from '@angular/material';
import {SimpleConfirmActionDialogComponent} from '../../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../../services/toast-messages.service';

interface Question {
  id: number;
  description: string;
}

@Component({
  templateUrl: './questions-dialog.component.html'
})
export class QuestionsDialogComponent implements OnInit {
  basicDetailsConfig: any;
  showBasicInfo = false;
  user: any;
  loading: boolean;
  displayColumns = ['description', 'actions'];
  questions: MatTableDataSource<Question> = new MatTableDataSource<Question>();

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.user = data.user;
    this.loading = false;
  }

  public async ngOnInit(): Promise<any> {
    await this.initBasicInfo();
    await this.initQuestions();
  }

  async initQuestions() {
    try {
      this.loading = true;
      this.questions.data = [];
      const result = await this.commonService.getList('questionnaire/question') as Question[];
      this.questions = new MatTableDataSource<Question>(result);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loading = false;
    }
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      subtitle: [{
        title: 'Ενέργειες ερωτήσεων',
        value: ''
      }],
      title: 'Ερωτήσεις'
    };

    await this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];

    const action2 = {
      function: () => {
        this.showCreateDialog();
      },
      showAction: true,
      title: 'Προσθήκη Ερώτησης',
      icon: 'add',
      color: '#013e81',
    };

    actions.push(action2);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }
    this.showBasicInfo = true;
  }

  search($event: any) {
    this.questions.filter = $event.target.value.trim().toLowerCase();
  }

  private showCreateDialog() {
    const createDialog = this.matDialog.open(CreateDialogComponent, {
      width: '550px',
      height: '150',
      data: {
        title: 'Δημιουργία ερώτησης',
        mode: 0,
        type: 0
      }
    });

    createDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.insertItem(`questionnaire/question`, {description: result});
          this.toastMessagesService.toastMessages('Η ερώτηση δημιουργήθηκε με επιτυχία');
          await this.initQuestions();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  showUpdateDialog(question) {
    const createDialog = this.matDialog.open(CreateDialogComponent, {
      width: '550px',
      height: '150',
      data: {
        title: 'Ενημέρωση ερώτησης',
        mode: 1,
        type: 0,
        inputData: question.description
      }
    });

    createDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          question.description = result;
          await this.commonService.updateObject(`questionnaire/question`, question);
          this.toastMessagesService.toastMessages('Η ερώτηση δημιουργήθηκε με επιτυχία');
          await this.initQuestions();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  deleteQuestion(element) {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Διαγραφή Ερώτησης',
        message: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την ερώτηση?'
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.deleteItem(`questionnaire/question`, element.id);
          this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
          await this.initQuestions();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }
}
